import { create } from 'zustand';
import type { UserResponseData } from './types';

interface UserState {
    user: UserResponseData | null;
    setUser: (user: UserResponseData | null) => void;
    clearUser: () => void;
}

export const useUserStore = create<UserState>((set) => ({
    user: null,
    setUser: (user) => set({ user }),
    clearUser: () => set({ user: null }),
}));
